// Import model
import { StartRoomSelectionRemoveItemRequest } from '../models/StartRoomSelectionRemoveItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartRoomSelectionRemoveItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartRoomSelectionRemoveItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartRoomSelectionRemoveItemRequest instance
   */
  static deserialize(json: string): StartRoomSelectionRemoveItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartRoomSelectionRemoveItemRequest instance
   */
  static fromObject(obj: any): StartRoomSelectionRemoveItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartRoomSelectionRemoveItemRequest');
    }


    const instance: StartRoomSelectionRemoveItemRequest = {
      source: obj['source'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartRoomSelectionRemoveItemRequest instances
   */
  static deserializeArray(json: string): StartRoomSelectionRemoveItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartRoomSelectionRemoveItemRequest instance to a JSON string
   */
  static serialize(instance: StartRoomSelectionRemoveItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartRoomSelectionRemoveItemRequest instance to a plain object
   */
  static toObject(instance: StartRoomSelectionRemoveItemRequest): any {
    return {
      'source': instance.source,
      'itemId': instance.itemId,
    };
  }

  /**
   * Serializes an array of StartRoomSelectionRemoveItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartRoomSelectionRemoveItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
